import AxiosInstance from 'utils/AxiosInstance'
import * as types from './types'
import { clientBaseUrl } from 'utils/AxiosInstance'

import {
  BASE_URL_API as baseURL,
  ACCESS_TOKEN as accessToken,
  randomString,
} from 'utils/helpers'
import { columns } from 'views/pages/ManagerReport/CustomReport/data'
import { CR_STATUS_FIELDS } from 'views/pages/ManagerReport/CustomReport/data'
import { CR_INCLUDE_USERS_VALUE } from 'views/pages/ManagerReport/CustomReport/data'
import { toast } from 'react-toastify'

export const setFinalSlide = (payload) => ({
  type: types.SET_FINAL_SLIDE,
  payload,
})

export const setDownloading = (payload) => ({
  type: types.SET_DOWNLOADING,
  payload,
})

export const setContinueDisabled = (condition, slide) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_CONTINUE_DISABLED, payload: condition })
    dispatch(setCompletedSlides(slide, condition))
  }
}

export const setCompletedSlides = (payload, remove) => {
  return (dispatch, getState) => {
    if (!payload) return
    const { completedSlides } = getState().customReports

    if (remove) {
      dispatch({
        type: types.SET_COMPLETED_SLIDES,
        payload: completedSlides.filter((slide) => slide !== payload),
      })
      return
    }

    if (completedSlides.includes(payload)) return

    dispatch({
      type: types.SET_COMPLETED_SLIDES,
      payload: [...completedSlides, payload],
    })
  }
}

export const setContinueButtonText = (payload) => ({
  type: types.SET_CONTINUE_BUTTON_TEXT,
  payload,
})

export const setSavingDownloading = (payload) => ({
  type: types.SET_SAVING_DOWNLOADING,
  payload,
})

export const setPossibleColumns = (payload) => ({
  type: types.SET_POSSIBLE_COLUMNS,
  payload,
})

export const setCurrentSlide = (slide) => ({
  type: types.SET_CURRENT_SLIDE,
  payload: slide,
})

export const setReportType = (type) => ({
  type: types.SET_REPORT_TYPE,
  payload: type,
})

export const setCourseReportType = (type) => ({
  type: types.SET_COURSE_REPORT_TYPE,
  payload: type,
})

export const setCourseGroupReportType = (type) => ({
  type: types.SET_COURSE_GROUP_REPORT_TYPE,
  payload: type,
})

// export const setAllCourseGroups = () => {
//   return (dispatch, getState) => {
//     const { groups: data } = getState().groups

//     const groups = data
//       .filter((group) => group.type === 'course')
//       .map((group) => {
//         return {
//           id: group.id,
//           name: group.name,
//         }
//       })

//     dispatch({ type: types.SET_ALL_COURSE_GROUPS, payload: groups })
//   }
// }

export const setAllCourseGroups = () => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      const { groups: data } = getState().groups

      const groups = data
        .filter((group) => group.type === 'course')
        .map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        })

      dispatch({ type: types.SET_ALL_COURSE_GROUPS, payload: groups })

      resolve()
    })
  }
}

export const setAllCourses = () => {
  return (dispatch, getState) => {
    const { selectedSingleCourse, selectedMultipleCourses } =
      getState().customReports

    return AxiosInstance.get('/custom-reports/courses').then((data) => {
      dispatch({ type: types.SET_ALL_COURSES, payload: data })

      if (selectedSingleCourse) {
        const course = data.find(
          (course) => course.course_id === selectedSingleCourse?.id
        )

        dispatch(
          setSingleCourse({
            id: course.course_id,
            name: course.name,
            hasQuiz: course.hasQuiz,
            hasChecklist: course.hasChecklist,
          })
        )
      }

      if (
        selectedMultipleCourses.length &&
        typeof selectedMultipleCourses[0] !== 'object'
      ) {
        const courses = data
          .filter((course) =>
            selectedMultipleCourses.map(Number).includes(course.course_id)
          )
          .map((course) => ({
            id: course.course_id,
            name: course.name,
          }))
        dispatch({ type: types.SET_MULTIPlE_COURSES, payload: courses })
      }

      return data
    })
  }
}

export const setSingleCourse = (course) => ({
  type: types.SET_SINGLE_COURSE,
  payload: course,
})

export const setSingleCourseGroup = (group) => ({
  type: types.SET_SINGLE_COURSE_GROUP,
  payload: group,
})

export const resetMultipleCourses = () => ({
  type: types.SET_MULTIPlE_COURSES,
  payload: [],
})

export const resetMultipleCourseGroups = () => ({
  type: types.SET_MULTIPLE_COURSE_GROUPS,
  payload: [],
})

export const setMultipleCourses = (course) => {
  return (dispatch, getState) => {
    const { selectedMultipleCourses: courses } = getState().customReports
    const courseIds = courses?.map((c) => c?.id)

    let newSelectedMultipleCourses = [...courses]
    if (!courseIds.includes(course.id)) {
      newSelectedMultipleCourses.push(course)
    } else {
      newSelectedMultipleCourses = courses.filter((c) => c.id !== course.id)
    }

    dispatch({
      type: types.SET_MULTIPlE_COURSES,
      payload: newSelectedMultipleCourses,
    })
  }
}

export const setMultipleCourseGroups = (group) => {
  return (dispatch, getState) => {
    const { selectedMultipleCourseGroups: groups } = getState().customReports
    const groupIds = groups?.map((c) => c?.id)

    let newSelectedMultipleCourseGroups = [...groups]
    if (!groupIds.includes(group.id)) {
      newSelectedMultipleCourseGroups.push(group)
    } else {
      newSelectedMultipleCourseGroups = groups.filter((c) => c.id !== group.id)
    }

    dispatch({
      type: types.SET_MULTIPLE_COURSE_GROUPS,
      payload: newSelectedMultipleCourseGroups,
    })
  }
}

export const setCourseLocationAndLocationGroups = () => {
  return (dispatch, getState) => {
    const { selectedSingleCourse: course } = getState().customReports

    return AxiosInstance.get(
      `/custom-reports/courses/locations/${course.id}`
    ).then((data) => {
      dispatch({ type: types.SET_COURSE_LOCATIONS, payload: data.locations })
      dispatch({
        type: types.SET_COURSE_LOCATION_GROUPS,
        payload: data.location_groups,
      })

      return data
    })
  }
}

export const setCourseGroupLocationAndLocationGroups = () => {
  return (dispatch, getState) => {
    const { selectedSingleCourseGroup: group } = getState().customReports

    return AxiosInstance.get(
      `/custom-reports/course-groups/locations/${group.id}`
    ).then((data) => {
      dispatch({
        type: types.SET_COURSE_GROUP_LOCATIONS,
        payload: data.locations,
      })
      dispatch({
        type: types.SET_COURSE_GROUP_LOCATION_GROUPS,
        payload: data.location_groups,
      })

      return data
    })
  }
}

export const setCourseRolesAndRoleGroups = () => {
  return (dispatch, getState) => {
    const { selectedSingleCourse: course } = getState().customReports

    AxiosInstance.get(`/custom-reports/courses/roles/${course.id}`).then(
      (data) => {
        console.log(data, 'leart221')
        dispatch({ type: types.SET_COURSE_ROLES, payload: data.roles })
        dispatch({
          type: types.SET_COURSE_ROLE_GROUPS,
          payload: data.role_groups,
        })
      }
    )
  }
}

export const setCourseGroupRolesAndRoleGroups = () => {
  return (dispatch, getState) => {
    const { selectedSingleCourseGroup: group } = getState().customReports

    AxiosInstance.get(`/custom-reports/course-groups/roles/${group.id}`).then(
      (data) => {
        dispatch({ type: types.SET_COURSE_GROUP_ROLES, payload: data.roles })
        dispatch({
          type: types.SET_COURSE_GROUP_ROLE_GROUPS,
          payload: data.role_groups,
        })
      }
    )
  }
}

export const setSelectedLocations = (locationId, tab) => {
  return (dispatch, getState) => {
    const {
      selectedLocations: { locations, type },
    } = getState().customReports

    let newSelectedLocations = [...locations]
    if (!newSelectedLocations.includes(locationId)) {
      newSelectedLocations.push(locationId)
    } else {
      newSelectedLocations = locations.filter((id) => id !== locationId)
    }

    dispatch({
      type: types.SET_SELECTED_LOCATIONS,
      payload: { locations: newSelectedLocations, type: tab },
    })
  }
}

export const setSelectedRoles = (roleId, tab) => {
  return (dispatch, getState) => {
    const {
      selectedRoles: { roles, type },
    } = getState().customReports

    let newSelectedRoles = [...roles]
    if (!newSelectedRoles.includes(roleId)) {
      newSelectedRoles.push(roleId)
    } else {
      newSelectedRoles = roles.filter((id) => id !== roleId)
    }

    dispatch({
      type: types.SET_SELECTED_ROLES,
      payload: { roles: newSelectedRoles, type: tab },
    })
  }
}

export const resetSelectedLocations = () => ({
  type: types.RESET_SELECTED_LOCATIONS,
})

export const resetSelectedRoles = () => ({
  type: types.RESET_SELECTED_ROLES,
})

const isFieldPresent = (previewColumns, column) => {
  const fields = previewColumns.map((c) => c.field)
  return fields.includes(column)
}

export const extractReport = (
  reportName,
  description = '',
  save = false,
  download = true,
  reset = true
) => {
  return async (dispatch, getState) => {
    if (!save) {
      dispatch(setDownloading(true))
    } else {
      if (download) dispatch(setSavingDownloading(true))
    }

    const {
      selectedSingleCourse: course,
      selectedRoles,
      courseRoles,
      courseRoleGroups,
      courseLocationGroups,
      courseLocations,
      previewColumns,
      report,
      selectedMultipleCourses,
      exactReportType,
      selectedSingleCourseGroup: group,
      courseGroupLocations,
      courseGroupLocationGroups,
      courseGroupRoles,
      courseGroupRoleGroups,
    } = getState().customReports

    let { selectedLocations } = getState().customReports

    let query = {}
    query.reportType = exactReportType

    const includeNrUsers = previewColumns.some((c) => !c.field)

    query.fields = previewColumns
      .filter((c) => c.field)
      .map((c) => c.field)
      .join(',')
    query.columns = previewColumns
      .filter((c) => c.field)
      .map((c) => c.headerName)
      .join(',')

    if (save) {
      query.savedFields = previewColumns
        .filter((c) => c.field || c.id)
        .map((c) => (c.field ? c.field : c.id))
        .join(',')
    }

    if (save && !reportName) {
      alert('You should enter a report name')
      return
    }

    if (selectedMultipleCourses.length) {
      query.course_ids =
        typeof selectedMultipleCourses[0] === 'object'
          ? selectedMultipleCourses.map((course) => course.id).join(',')
          : selectedMultipleCourses.join(',')
    }

    if (course?.id) {
      query.course_id = course.id
    }

    if (group?.id) {
      query.group_id = group.id
    }

    if (reportName) query.reportName = reportName
    if (description) query.description = description
    if (save) query.save = save
    if (report) query.reportId = report.id
    if (!download) query.noDownload = true

    if (isFieldPresent(previewColumns, 'quizPassed')) query.quizPassed = true
    if (isFieldPresent(previewColumns, 'firstAttemptPassed'))
      query.firstAttemptPassed = true

    if (includeNrUsers) {
      query.includeNrUsers = true
    }

    if (selectedLocations.locations && selectedLocations.locations.length) {
      if (selectedLocations.type === 0) {
        query.locations = selectedLocations.locations.join(',')
      } else if (selectedLocations.type === 1) {
        // selectedLocations.locations = [
        //   ...selectedLocations.locations,
        //   567,
        //   564,
        //   576,
        //   570,
        //   571,
        //   572,
        //   573,
        //   574,
        // ]
        query.location_groups = selectedLocations.locations.join(',')
      }
    }

    if (!selectedLocations?.locations?.length) {
      const locations = [0, 1].includes(exactReportType)
        ? courseLocations
        : courseGroupLocations

      const locationGroups = [0, 1].includes(exactReportType)
        ? courseLocationGroups
        : courseGroupLocationGroups

      query.locations = locations.length
        ? locations.map((location) => location.id).join(',')
        : ''
      query.location_groups = locationGroups.length
        ? locationGroups.map((location) => location.id).join(',')
        : ''
    } else {
      if (selectedLocations.type === 0) {
        query.locations = selectedLocations.locations.join(',')
      } else if (selectedLocations.type === 1) {
        query.location_groups = selectedLocations.locations.join(',')
      }
    }

    if (!selectedRoles?.roles?.length) {
      const roles = [0, 1].includes(exactReportType)
        ? courseRoles
        : courseGroupRoles

      const roleGroups = [0, 1].includes(exactReportType)
        ? courseRoleGroups
        : courseGroupRoleGroups

      query.roles = roles.length ? roles.map((role) => role.id).join(',') : ''
      query.role_groups = roleGroups.length
        ? roleGroups.map((role) => role.id).join(',')
        : ''
    } else {
      if (selectedRoles.type === 0) {
        query.roles = selectedRoles.roles.join(',')
      } else if (selectedRoles.type === 1) {
        query.role_groups = selectedRoles.roles.join(',')
      }
    }

    const queryEntires = Object.entries(query)
    let queryString = ``

    queryEntires &&
      queryEntires.length &&
      queryEntires.map(([key, value]) => {
        queryString += `&${key}=${value}`
      })

    // window.open(
    //   clientBaseUrl() +
    //     `/custom-reports/extract-report?token=${accessToken()}${queryString}`,
    //   '_blank'
    // )
    // return

    console.log(queryString, 'leart523')

    if (!download) {
      AxiosInstance.get(`/custom-reports/extract-report?${queryString}`).then(
        () => {
          if (reset) {
            dispatch(resetEverything())
          }
        }
      )
      return
    }

    try {
      const response = await fetch(
        clientBaseUrl() +
          `/custom-reports/extract-report?token=${accessToken()}${queryString}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      if (response.status === 409) {
        throw new Error(
          'This report name already exists! Please use another name.'
        )
      }

      if (!response.ok) {
        throw new Error('Failed to fetch report')
      }

      const blob = await response.blob()

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = reportName || 'report.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      if (reset) {
        dispatch(setDownloading(false))
        dispatch(setSavingDownloading(false))
        dispatch(resetEverything())
      }
      dispatch(setDownloadingFromMainPage(false))
    } catch (error) {
      console.error(error.message, error)
      alert(error.message)
      dispatch(setDownloading(false))
      dispatch(setSavingDownloading(false))
      dispatch(setDownloadingFromMainPage(false))
    }
  }
}

export const sendEmailReport = (reportId) => {
  return (dispatch, getState) => {
    const { admins } = getState().customReports

    const users = admins
      .filter((admin) => admin.selected)
      .map((admin) => {
        return {
          report_id: +reportId,
          email: admin.email,
        }
      })

    AxiosInstance.post(`/custom-reports/email/${reportId}`, { users }).then(
      () => {
        toast.success(`Report emailed successfully`, {
          position: toast.POSITION.TOP_CENTER,
          className: 'general-settings-toast',
          autoClose: 2500,
        })
      }
    )
  }
}

export const setPreviewColumns = (payload) => ({
  type: types.SET_PREVIEW_COLUMNS,
  payload,
})

export const setPreviewRows = (payload) => ({
  type: types.SET_PREVIEW_ROWS,
  payload,
})

const modifyCourseGroupLocations = (
  selectedLocations,
  courseGroupLocations,
  courseGroupLocationGroups
) => {
  const areLocationsSelected =
    selectedLocations.type !== 1 && selectedLocations.locations.length

  let selectedLocationsModified = []
  let locationGroupStores = []

  if (selectedLocations.type === 1) {
    const selectedLocationGroups = courseGroupLocationGroups.filter(
      (locationGroup) => selectedLocations.locations.includes(locationGroup.id)
    )
    selectedLocationGroups.forEach((locationGroup) => {
      locationGroupStores.push(...locationGroup.stores)
    })
  }

  if (areLocationsSelected || locationGroupStores.length) {
    const array = areLocationsSelected
      ? selectedLocations.locations
      : locationGroupStores

    array.forEach((location) => {
      const res = courseGroupLocations.find(
        (courseLocation) => courseLocation.id === location
      )

      selectedLocationsModified.push(res)
    })
  }

  let locations = selectedLocationsModified.length
    ? selectedLocationsModified
    : courseGroupLocations

  return locations
}

export const setPreviewTable = (type) => {
  return async (dispatch, getState) => {
    const {
      selectedSingleCourse,
      selectedLocations,
      editingReport,
      allCourses,
      previewColumns,
      courseLocationGroups,
      selectedReportType,
      selectedSingleCourseGroup,
      allCourseGroups,
      exactReportType,
    } = getState().customReports

    let { courseLocations } = getState().customReports
    let { selectedMultipleCourses } = getState().customReports
    let { courseGroupLocations, courseGroupLocationGroups } =
      getState().customReports

    const areLocationsSelected =
      selectedLocations.type !== 1 && selectedLocations.locations.length

    let selectedLocationsModified = []
    let locationGroupStores = []

    if (selectedLocations.type === 1) {
      const selectedLocationGroups = courseLocationGroups.filter(
        (locationGroup) =>
          selectedLocations.locations.includes(locationGroup.id)
      )
      selectedLocationGroups.forEach((locationGroup) => {
        locationGroupStores.push(...locationGroup.stores)
      })
    }

    if (areLocationsSelected || locationGroupStores.length) {
      if (
        (!courseLocations || !courseLocations.length) &&
        [0, 1].includes(exactReportType)
      ) {
        await dispatch(setCourseLocationAndLocationGroups())

        courseLocations = getState().customReports.courseLocations
      }

      const array = areLocationsSelected
        ? selectedLocations.locations
        : locationGroupStores

      array.forEach((location) => {
        const res = courseLocations.find(
          (courseLocation) => courseLocation.id === location
        )
        selectedLocationsModified.push(res)
      })
    }

    let locations = selectedLocationsModified.length
      ? selectedLocationsModified
      : courseLocations

    /**
     * Call this function if its a course group report type
     */
    if (
      [2, 3].includes(exactReportType) &&
      (!courseGroupLocations || !courseGroupLocations.length)
    ) {
      const data = await dispatch(setCourseGroupLocationAndLocationGroups())
      courseGroupLocations = data.locations
      courseGroupLocationGroups = data.location_groups
    }
    if (selectedReportType === 1) {
      locations = modifyCourseGroupLocations(
        selectedLocations,
        courseGroupLocations,
        courseGroupLocationGroups
      )
    }

    let courseName = selectedSingleCourse?.name
    let courseGroupName = selectedSingleCourseGroup?.name

    if (selectedSingleCourse && !('name' in selectedSingleCourse)) {
      if (!allCourses || !allCourses.length) {
        await dispatch(setAllCourses())
      }

      const updatedCourses = getState().customReports.allCourses
      courseName = updatedCourses.find(
        (course) => course.course_id === selectedSingleCourse.id
      )?.name
    }

    if (selectedSingleCourseGroup && !('name' in selectedSingleCourseGroup)) {
      if (!allCourseGroups || !allCourseGroups.length) {
        await dispatch(setAllCourseGroups())
      }

      const updatedCourseGroups = getState().customReports.allCourseGroups

      courseGroupName = updatedCourseGroups.find(
        (group) => group.id === selectedSingleCourseGroup.id
      )?.name
    }

    if (
      exactReportType === 1 &&
      typeof selectedMultipleCourses[0] !== 'object'
    ) {
      await dispatch(setAllCourses())

      const updatedCourses = getState().customReports.allCourses
      const multipleCoursesids = selectedMultipleCourses.map((c) => +c)

      selectedMultipleCourses = updatedCourses.filter((course) =>
        multipleCoursesids.includes(course.course_id)
      )
    }

    const defaultColumnsLength = columns[type].default.length
    const rows = previewColumns.slice(defaultColumnsLength)

    switch (type) {
      case 0:
        if (!editingReport) {
          dispatch(
            setPreviewRows(
              Array.from({ length: locations?.length }, (_, index) => ({
                name: courseName,
                Region: 'TBD',
                Area: 'TBD',
                Location: locations?.at(index)?.name,
              }))
            )
          )
        } else {
          dispatch(
            setPreviewRows(
              Array.from({ length: locations.length }, (_, index) => ({
                name: courseName,
                Region: 'TBD',
                Area: 'TBD',
                Location: locations?.at(index)?.name,
                ...Object.fromEntries(rows.map((row) => [row.field, row.val])),
              }))
            )
          )
        }
        break

      case 1:
        dispatch(
          setPreviewRows(
            selectedMultipleCourses.map((course) => {
              return {
                name: course.name,
                ...Object.fromEntries(rows.map((row) => [row.field, row.val])),
              }
            })
          )
        )
        break
      case 2:
        dispatch(
          setPreviewRows(
            Array.from({ length: locations.length }, (_, index) => ({
              name: courseGroupName,
              Region: 'TBD',
              Area: 'TBD',
              Location: locations?.at(index)?.name,
              ...Object.fromEntries(rows.map((row) => [row.field, row.val])),
            }))
          )
        )
        break
      default:
        return ''
    }

    if (!editingReport) {
      dispatch(setPreviewColumns(columns[type].default))
    }
  }
}

const appendStatusNumberOfUsers = (previewRows) => {
  const alreadyAppended = Object.values(previewRows?.at(0))?.some((val) =>
    val?.includes(CR_INCLUDE_USERS_VALUE)
  )

  if (alreadyAppended) return previewRows

  const updatedRows = previewRows.map((row) => {
    return Object.fromEntries(
      Object.entries(row).map(([key, val]) => [
        key,
        CR_STATUS_FIELDS.includes(key)
          ? `${val} ${CR_INCLUDE_USERS_VALUE}`
          : val,
      ])
    )
  })

  return updatedRows
}

export const includeNumberOfUsers = () => {
  return (dispatch, getState) => {
    const { previewRows } = getState().customReports
    const updatedRows = appendStatusNumberOfUsers(previewRows)
    dispatch(setPreviewRows(updatedRows))
  }
}

export const removeNumberOfUsers = (appendValue) => {
  return (dispatch, getState) => {
    const { previewRows } = getState().customReports

    const updatedRows = previewRows.map((row) => {
      return Object.fromEntries(
        Object.entries(row).map(([key, val]) => [
          key,
          typeof val === 'string' && val.endsWith(` ${appendValue}`)
            ? val.slice(0, -appendValue.length - 1)
            : val,
        ])
      )
    })

    dispatch(setPreviewRows(updatedRows))
  }
}

export const fetchSavedReports = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/custom-reports/saved-reports`).then((data) => {
      if (data && data.length) {
        dispatch({ type: types.SET_SAVED_REPORTS, payload: data })
        dispatch({
          type: types.SET_SAVED_REPORTS_ROWS,
          payload: data.map(
            ({
              name,
              description,
              id,
              user_id,
              edit_mode,
              email_report,
              email_frequency,
            }) => {
              return {
                name,
                description,
                id,
                user_id,
                edit_mode,
                email_report,
                email_frequency,
              }
            }
          ),
        })
      } else {
        dispatch({ type: types.SET_SAVED_REPORTS, payload: [] })
        dispatch({
          type: types.SET_SAVED_REPORTS_ROWS,
          payload: [],
        })
      }
    })
  }
}

export const deleteReport = (id) => {
  return (dispatch, getState) => {
    // eslint-disable-next-line
    if (!confirm('Are you sure you want to delete this report?')) {
      return
    }
    AxiosInstance.delete(`/custom-reports/saved-reports/${id}`).then(() => {
      dispatch(fetchSavedReports())
    })
  }
}

export const setReport = (payload) => ({ type: types.SET_REPORT, payload })

export const editReport = (id) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_EDITING_REPORT, payload: true })
    const { savedReports, allCourses } = getState().customReports

    const report = savedReports.find((report) => report.id === id)

    console.log(report.config.reportType, 'leart938')

    dispatch(dispatchExactReportType(report.config.reportType))

    dispatch(setReport(report))

    const defaultFields = columns[report.config.reportType].default
    const possibleFields = columns[report.config.reportType].possible

    const filteredFields = possibleFields.filter(
      (item) =>
        report.config.fields.includes(item.field) ||
        report.config.fields.includes(item.id)
    )

    const locations = {
      locations: report?.config?.locations?.map((l) => +l),
      type: 0,
    }
    const location_groups = {
      locations: report?.config?.location_groups?.map((lg) => +lg),
      type: 1,
    }
    const roles = { roles: report?.config?.roles?.map((r) => +r), type: 0 }
    const role_groups = {
      roles: report?.config?.role_groups?.map((r) => +r),
      type: 1,
    }

    const finalLocations = locations?.locations?.length
      ? locations
      : location_groups

    const finalRoles = roles?.roles?.length ? roles : role_groups

    dispatch({ type: types.SET_SELECTED_LOCATIONS, payload: finalLocations })
    dispatch({ type: types.SET_SELECTED_ROLES, payload: finalRoles })

    switch (report.config.reportType) {
      case 0:
        dispatch(
          setSingleCourse({
            id: +report.config.course_id,
          })
        )
        break
      case 1:
        dispatch({
          type: types.SET_MULTIPlE_COURSES,
          payload: report.config.courseIds,
        })
        break
      case 2:
        dispatch(setSingleCourseGroup({ id: +report.config.group_id }))
        break
      default:
    }

    dispatch(setPreviewColumns([...defaultFields, ...filteredFields]))
  }
}

export const setShowSelectedOnly = (payload) => ({
  type: types.SET_FILTER_SELECTED_ONLY,
  payload,
})

export const setDownloadingFromMainPage = (payload) => ({
  type: types.SET_DOWNLOADING_FROM_MAIN_PAGE,
  payload,
})

const dispatchExactReportType = (payload) => {
  console.log(payload, 'leart36')

  return (dispatch, getState) => {
    const {
      selectedReportType,
      selectedCourseReportType,
      selectedCourseGroupReportType,
    } = getState().customReports

    if (!selectedReportType) {
      const newReportType = [0, 1].includes(payload) ? 0 : 1
      dispatch(setReportType(newReportType))

      if (newReportType === 0 && !selectedCourseReportType) {
        dispatch(setCourseReportType(payload === 0 ? 0 : 1))
      }

      if (newReportType === 1 && !selectedCourseGroupReportType) {
        dispatch(setCourseGroupReportType(payload === 2 ? 0 : 1))
      }
    }

    dispatch({ type: types.SET_EXACT_REPORT_TYPE, payload })
  }
}

export const setAdmins = (payload) => ({ type: types.SET_ADMINS, payload })

export const fetchAdmins = (reportId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/custom-reports/admins/${reportId}`).then((data) =>
      dispatch(setAdmins(data))
    )
  }
}

/**
 * Excepts the adminId which is being updated and type of property being updated
 * share / edit
 */
export const updateAdmins = (adminId, type) => {
  return (dispatch, getState) => {
    const { admins } = getState().customReports

    const admin = admins.find((el) => el.id === adminId)

    if (type === 'share') {
      admin.selected = admin.selected === 1 ? 0 : 1
    } else {
      admin.edit_mode = admin.edit_mode === 1 ? 0 : 1
    }

    const updatedAdmins = admins.map((el) =>
      el.id === adminId ? { ...admin } : el
    )

    dispatch(setAdmins(updatedAdmins))
  }
}

export const updateSharedReport = (reportId, emailData) => {
  return (dispatch, getState) => {
    const { admins } = getState().customReports
    AxiosInstance.put(`/custom-reports/admins/${reportId}`, {
      data: {
        admins,
        email_report: emailData.emailReport ? 1 : 0,
        email_frequency: emailData.emailFrequency,
      },
    }).then(() => {
      dispatch(fetchSavedReports())
    })
  }
}

export const setExactReportType = () => {
  return (dispatch, getState) => {
    const {
      selectedReportType,
      selectedCourseReportType,
      selectedCourseGroupReportType,
    } = getState().customReports

    console.log(selectedReportType, selectedCourseReportType, 'leart1094')

    if (selectedReportType === 0) {
      if (selectedCourseReportType === 0) dispatch(dispatchExactReportType(0))
      if (selectedCourseReportType === 1) dispatch(dispatchExactReportType(1))
    }

    if (selectedReportType === 1) {
      if (selectedCourseGroupReportType === 0)
        dispatch(dispatchExactReportType(2))
      if (selectedCourseGroupReportType === 1)
        dispatch(dispatchExactReportType(3))
    }
  }
}

export const resetEverything = () => ({ type: types.RESET_EVERYTHING })
